<section class="w-full h-full flex flex-wrap bg-white dark:bg-gray-800">
  <header class="w-full flex md:hidden">
    <p class="font-medium text-base mt-4 md:mt-0">ثبت‌نام | ورود</p>
  </header>
  <div class="w-full flex flex-wrap justify-center content-between items-center">
    <div class="w-full flex flex-wrap justify-center items-center">
      <swiper-container #auth_slider class="!w-full flex flex-wrap justify-center" init="false">
        @for (slide of slides; track $index) {
          <swiper-slide class="w-full flex flex-wrap justify-center bg-white dark:bg-gray-800">
            <div class="w-full flex flex-wrap justify-center bg-white dark:bg-gray-800">
              <img class="w-[267px] h-[200px] md:!h-[unset] md:aspect-[1.34] md:w-1/3" [src]="slide.img" alt="image" />
              <span class="w-full font-medium text-base text-center mt-12 md:mt-6">{{ slide.title }}</span>
              <span class="w-full font-regular text-sm text-center mt-4">{{ slide.description }}</span>
            </div>
          </swiper-slide>
        }
      </swiper-container>

    </div>

    <div class="w-full flex flex-wrap justify-center mt-4 md:mt-3">
      @for (item of [1, 1, 1]; track $index) {
        <span
          class="h-2 rounded-full"
          [ngClass]="{ 'bg-green-500 w-4': $index === activeSlideIndex(), 'bg-gray-300 w-2': $index !== activeSlideIndex(), 'mx-1': $index === 1 }">
        </span>
      }
    </div>

  </div>
</section>
